const Welcome = () => {
  return (
    <div
      style={{
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <h1
        style={{
          fontSize: '1.2rem',
          fontWeight: 'bold',
          color: 'var(--teal)',
        }}
      >
        Welcome to Earmark!
      </h1>
      <p>
        Think of us as Audible for blog posts. Paste the URL of a blog post or
        article into the home page, and we'll convert it to audio using AI. You
        can start listening immediately, or wait for later. You can listen on
        any device - we even support mobile playback and controls so you can use
        it just like Spotify or Audible.
      </p>
      <p>
        Your <strong>Queue</strong> is everything you've added but haven't
        finished listening too, oldest first. It will auto-play until it's
        cleared. You can find everything you've listened to in the{' '}
        <strong>History</strong> tab.
      </p>
      <p>
        This is our MVP, a no-frills, quick-and-dirty implementation of the
        idea. For now, Earmark is totally free, but to listen more than 30
        minutes you ahve to sign in with Google. I've added $100 to my OpenAI
        budget and when that runs out, we'll decide where to go next. We'd love
        your feedback at{' '}
        <a href="mailto:support@earmark.fm" style={{ color: 'var(--teal)' }}>
          support@earmark.fm
        </a>
        .
      </p>
      <p style={{ fontSize: '0.9rem', color: 'var(--muted)' }}>
        Happy listening! -{' '}
        <a href="https://x.com/granawkins" style={{ color: 'var(--teal)' }}>
          granawkins
        </a>
      </p>
    </div>
  );
};

export default Welcome;
